import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { map } from 'rxjs/operators';

import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
import { MeiosPagamento, IMeiosPagamento } from '../../../../models/meiosPagamento.model';
import { Operacoes, IOperacoes } from '../../../../models/operacoes.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';



@Component({
  selector: 'app-meiosPagamento',
  templateUrl: './meios-pagamento.component.html',
  styleUrls: ['./meios-pagamento.component.scss']
})
export class MeiosPagamentoComponent extends DataModelComponent<IMeiosPagamento> implements OnInit, OnDestroy {
  operacoesClass: Operacoes;
  operacoes: IOperacoes[];
  operacoesEvent:Subscription;
  dataSource: Array<any> = [];
  dataClass: MeiosPagamento;
  dataEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [{ field: "nome", text: "Título" },
  { field: "operacao", text: "Cod.Operação" },
  { field: "ordem", text: "Ordem" },
  { field: "maxParcelas", text: "Max.Parc." },
  ];

  constructor(private db: AngularFirestore) {
    super({
      nome: new FormControl(),
      operacao: new FormControl('111'),
      ordem: new FormControl(0),
      maxParcelas: new FormControl(1),
      img: new FormControl(''),
      inativo: new FormControl(),
    });
    this.dataClass = new MeiosPagamento(db);
    this.operacoesClass = new Operacoes(db);
  }

  ngOnInit() {
    this.operacoesEvent = this.operacoesClass.changedEvent.subscribe(
      d=>{
        this.operacoes = d;
        if (this.operacoes.length==0)
           this.cadastrarOperacoes;
      })
      this.operacoesClass.verInativo = false;

    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        this.dataSource = d.sort(function(a:any,b:any) {return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);} );
      });
    this.dataClass.verInativo = false;
  }

  cadastrarOperacoes(){
    let qry = new Operacoes(this.db);
    qry.addList(
      [
        {codigo:'111',nome:"Dinheiro", ordem:1},
        {codigo:'112',nome:"Faturar", ordem:2},
        {codigo:'113',nome:"Pgto Cheque", ordem:3},
        {codigo:'114',nome:"Cartão Crédito", ordem:4},
        {codigo:'117',nome:"Cartão Debito", ordem:5},
        {codigo:'119',nome:"Outros", ordem:6},
      ]
    )
  }

  ngOnDestroy() {
    this.dataEvent.unsubscribe();
    this.operacoesEvent.unsubscribe();
  }

  doPostItem(event) {
    this.dataClass.post(this.item);
    super.doPostItem(event);
  }

  getFilterAttrib() {
    return 'ver inativos';
  }

  doCheckFilter(x: boolean) {
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }

  doChangeImage(arq){
    this.item.img = arq;
  }


}
